<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <main id="sobre" class="l-main">
        <div class="post">
          <div class="block block--white mt-1">
            <div class="container ct-top">
              <div class="post__body mt-4">
                <h1 v-text="translate.title"></h1>
                <h3 class="d-none d-md-block u-mb-md-3" v-text="translate.subTitle"></h3>
                <div class="text-body" v-html="translate.boxText"></div>
              </div>
            </div>
          </div>
          <div class="block block--gray u-mb-1 u-mb-md-1">
            <div class="container">
              <div class="post__body">
                <h3>
                  {{ translate.benefits }}
                </h3>
                <p v-html="translate.subBenefits" class="subBenefits u-mb-1 u-mb-md-1"></p>
                <ul class="bulleted-list u-mb-1 u-mb-md-0 mt-4">
                  <li v-for="(list, index) in translate.listBenefits" :key="index">
                    <div class="d-flex">
                      <div><img :src="imgPath" alt="Icone BDS" /></div>
                      <div>{{ list }}</div>
                    </div>
                  </li>
                </ul>
                <div class="mt-5 d-flex flex-row align-items-center">
                  <div class="contact-us" v-text="translate.contactUs"></div>
                  <router-link :to="{ name: 'ContactUsPage', params: { locale: $route.params.locale } }"
                    class="px-2 u-link">
                    {{ translate.linkContactUs }} </router-link>.
                </div>
              </div>
            </div>
          </div>
          <div class="py-5">
            <BannerAssineHorizontal :path="bannerAssineHorizontal" />
          </div>
        </div>
      </main>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import aboutTradutor from 'tradutors/about'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import IconeBds from 'assets/img/icone_BDS.png'
import api from '../../api'
import { isMobile } from "../shared/utils/mobile";

export default defineComponent({
  name: 'AboutView',
  head() {
    return {
      templateParams: {
        subTitle: null, 
        subPage: this.translate.title,
        page_url: window.location.origin + this.$route.fullPath,
        page_description: this.locale === 'pt-br'? 
        `A maior e melhor revista masculina do Brasil, desde 2001 fazendo história.`: 
        `The biggest and best male magazine in Brazil, since 2001 making history.`,
        page_image: '/favicon.ico',
        page_keywords: 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/sobre",
        page_url_en: "https://belladasemana.com.br/en/sobre",
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,        
      }
    }
  },
  computed: {
    ...mapState(localeStore, ['locale']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return aboutTradutor.portugues
      } else {
        return aboutTradutor.ingles
      }
    }
  },
  watch: {
    'locale': function () {
      this.getBannerAssineHorizontal(true)
    }
  },
  mounted() {
    this.getBannerAssineHorizontal()
    //console.log(this.$route)
  },
  data() {
    return {
      imgPath: IconeBds,
      bannerAssineHorizontal: '',
      isMobile: isMobile(),      
    }
  },
  created() {
    const lang = ['pt-br', 'en']
    if (lang.indexOf(this.$route.params.locale) === -1) {
      window.location.replace('/')
    }
  },
  methods: {
    async getBannerAssineHorizontal(changeLanguage = false) {
      if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
      api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
        this.bannerAssineHorizontal = data.bannerAssineHorizontal
        sessionStorage.setItem(
            "bannerAssineHorizontal",
            JSON.stringify(this.bannerAssineHorizontal)
          );
      })
      else
        this.bannerAssineHorizontal = JSON.parse(
          sessionStorage.getItem("bannerAssineHorizontal")
        );
    }
  }
})
</script>

<style lang="css" scoped>
.slot-body {
  margin-top: 65px !important;
  background-color: #fff !important;
}

img {
  width: 100%;
  object-fit: cover;
}

h1 {
  font-family: 'Bebas-Neue-Light';
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.post__body {
  margin-bottom: 0px;
}

.post__body h3 {
  color: #B20000;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.text-body>>>span {
  color: #5b5858;
  font-family: 'Roboto-Regular';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.post__body img {
  width: 17px;
  height: 18px;
  margin-right: 10px;
  object-fit: cover;
}

.subBenefits {
  color: #5b5858;
  font-family: 'Roboto-Regular';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

:deep(.bulleted-list li) {
  color: #000000;
  font-family: "Exo-2";
  font-size: 18px;
  letter-spacing: 0;
  line-height: 18px;
}

.contact-us {
  height: 19px;
  color: #5b5858;
  font-family: 'Roboto-Regular';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

@media screen and (max-width: 769px) {
  .img-mobile {
    display: none;
  }

  .ct-top {
    margin-top: 50px;
  }

  h1 {
    font-family: 'Bebas-Neue-Light';
    color: #000000;
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 58px;
  }

}
</style>
